module.exports = __webpack_public_path__ + "img/zhejiang.4f982163.jpg";